import FloatingVideo, { Position, AspectRatio } from './floating';
export type { FloatingVideoProps } from './floating';
export { Position, AspectRatio };
export default FloatingVideo;
